import React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Users, Award, Globe, Lock, FileText } from 'lucide-react';

export const B2BLandingPage = () => {
  return (
    <div>
      <Navigation />
      <WhatsAppButton variant="floating" />

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #333333 100%)',
        padding: '120px 0 80px',
        textAlign: 'center',
        color: 'white'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ color: 'white', marginBottom: '24px' }}>
            Indotravelista B2B Travel Trade Partners
          </h1>
          <p className="body-large" style={{ color: 'rgba(255,255,255,0.9)', maxWidth: '800px', margin: '0 auto 40px' }}>
            Connect with a trusted network of travel professionals, product and service providers, and destination partners supporting Indonesia and international markets.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link
              to="/b2b/login"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '14px 32px',
                background: 'white',
                color: '#1a1a1a',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: 500,
                borderRadius: 0
              }}
            >
              <Lock size={20} />
              Agent Login
            </Link>
            <Link
              to="/b2b/register"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '14px 32px',
                background: 'transparent',
                color: 'white',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: 500,
                border: '2px solid white',
                borderRadius: 0
              }}
            >
              <FileText size={20} />
              Become a B2B Partner
            </Link>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
              Why Partner with Indotravelista?
            </h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              Join a growing ecosystem of travel trade professionals
            </p>
          </div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '40px'
          }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ color: 'var(--text-primary)', marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                <Users size={48} />
              </div>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Travel Trade & Distribution Partners
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Travel agencies, wholesalers, consortia, OTAs, and destination specialists distributing travel products across Indonesia and international markets.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ color: 'var(--text-primary)', marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                <Award size={48} />
              </div>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Product & Service Partners
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Tour operators, DMCs, hotels, transportation providers, and experience suppliers serving Indonesia and international travel markets.
              </p>
            </div>
            <div style={{ textAlign: 'center' }}>
              <div style={{ color: 'var(--text-primary)', marginBottom: '20px', display: 'flex', justifyContent: 'center' }}>
                <Globe size={48} />
              </div>
              <h3 className="heading-2" style={{ marginBottom: '12px' }}>
                Destination Partners
              </h3>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Tourism boards, DMOs, CVBs, and destination organizations promoting cities, regions, and countries to the global travel trade.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)', textAlign: 'center' }}>
        <div className="container">
          <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
            Ready to Join?
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
            Already a partner? Login to access your portal. New to Indotravelista? Register now.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/b2b/login" className="btn-primary">
              Agent Login
            </Link>
            <Link to="/b2b/register" className="btn-secondary">
              Become a B2B Partner
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
